import { api, wrappedCollectionFetcher } from "services/api.service";
import { defaultKindMovementRule } from "types/locationManagement/kindMovementRule";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  const locationKindsRes = await wrappedCollectionFetcher<LocationManagementLocationKind>(
    "/location_management/location_kinds?page[size]=100",
  );
  const locationKinds = locationKindsRes.rows || [];
  return { kindMovementRule: defaultKindMovementRule, locationKinds };
});

export async function action({ request }: { request: Request }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/kind_movement_rules`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    return redirect("/kind-movements");
  }
  return res;
}
